module.exports = __webpack_public_path__ + "img/suqian.7dd087a.png";